import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ICU from "i18next-icu";
import translations from "./translations.json";

i18n
  .use(ICU)
  .use(initReactI18next)
  .init({
    resources: translations,
    lng: "sr",
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    icu: {
      format: (value, format, lng) => {
        if (value instanceof Date) {
          // example: format date/time
          return new Intl.DateTimeFormat(lng, {
            hour: "2-digit",
            minute: "2-digit",
          }).format(value);
        }
        return value;
      },
    },
  });

export default i18n;
